import { selectIsSocketReconnecting } from 'modules/webSocket/state';
import { useAppSelector } from 'store';

import { ReconnectingModal } from './ReconnectingModal';

export const ReconnectingModalContainer = () => {
  const isReconnecting = useAppSelector(selectIsSocketReconnecting);

  return <ReconnectingModal isOpen={isReconnecting} />;
};
